var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as Bluebird from "bluebird";
import h from "../helper/helper";
import screenSizeService from "./screenSize.service";
import FileUpload from "./fileUpload.service";
import blobService from "./blobService";
import Queue from "../asset/Queue";
var imageLib = require("blueimp-load-image/js/load-image");
var canvasToBlob = Bluebird.promisify(h.canvasToBlob.bind(h));
var PREVIEWSDISABLED = false;
var defaultOptions = {
    minimumSizeDifference: 1024,
    sizes: [
        {
            name: "lowest",
            restrictions: {
                maxWidth: 640,
                maxHeight: 480
            }
        },
        {
            name: "middle",
            restrictions: {
                maxWidth: 1280,
                maxHeight: 720
            }
        },
        {
            name: "highest",
            restrictions: {
                maxWidth: 2560,
                maxHeight: 1440
            }
        }
    ],
    gifSizes: [
        {
            name: "lowest",
            restrictions: {
                maxWidth: 640,
                maxHeight: 480
            }
        },
        {
            name: "highest"
        }
    ],
    gif: true,
    encrypt: true,
    extraInfo: {}
};
/* TODO:
    - maximum size for a resolution
    - original: enable, remove meta-data (exif etc.)
*/
if (screenSizeService.mobile) {
    defaultOptions.sizes = defaultOptions.sizes.filter(function (size) {
        return size.name !== "highest";
    });
}
var uploadQueue = new Queue(3);
uploadQueue.start();
var resizeQueue = new Queue(1);
resizeQueue.start();
var sizeDiff = function (a, b) {
    return a.blob.getSize() - b.blob.getSize();
};
var sizeSorter = function (a, b) {
    return sizeDiff(b, a);
};
var ImageUpload = /** @class */ (function (_super) {
    __extends(ImageUpload, _super);
    function ImageUpload(file, options) {
        var _this = _super.call(this, file, options || defaultOptions) || this;
        _this.rotation = "0";
        _this.convertForGallery = function () {
            return {
                upload: _this,
                highest: {
                    loading: false,
                    loaded: true,
                    url: _this.getUrl()
                },
                lowest: {
                    loading: false,
                    loaded: true,
                    url: _this.getUrl()
                }
            };
        };
        _this.rotate = function () {
            return _this.generatePreviews().then(function (previews) {
                var newDegree = "0";
                switch (_this.rotation) {
                    case "0":
                        newDegree = "90";
                        break;
                    case "90":
                        newDegree = "180";
                        break;
                    case "180":
                        newDegree = "270";
                        break;
                }
                _this.rotation = newDegree;
                _this.previewUrl = h.toUrl(previews[newDegree]);
                return previews[newDegree];
            });
        };
        _this.generatePreviews = h.cacheResult(function () {
            if (PREVIEWSDISABLED) {
                return Bluebird.reject(new Error("Previews are disabled"));
            }
            return ImageUpload.imageLibLoad(h.toUrl(_this.file), {
                maxHeight: 200, canvas: true
            }).then(function (img) {
                return Bluebird.all([
                    canvasToBlob(img, "image/jpeg"),
                    canvasToBlob(ImageUpload.rotate90(img), "image/jpeg"),
                    canvasToBlob(ImageUpload.rotate180(img), "image/jpeg"),
                    canvasToBlob(ImageUpload.rotate270(img), "image/jpeg")
                ]);
            }).spread(function (preview0, preview90, preview180, preview270) {
                _this.previewUrl = h.toUrl(preview0);
                return {
                    "0": preview0,
                    "90": preview90,
                    "180": preview180,
                    "270": preview270,
                };
            });
        });
        _this.getPreviewUrl = function () {
            return _this.previewUrl || _this.getUrl();
        };
        _this.getUrl = function () {
            if (!PREVIEWSDISABLED) {
                _this.generatePreviews();
            }
            _this.url = _this.url || h.toUrl(_this.file);
            _this.previewUrl = _this.previewUrl || _this.url;
            return _this.url;
        };
        _this.upload = function (encryptionKey) {
            if (!_this.blobs) {
                throw new Error("usage error: prepare was not called!");
            }
            if (_this.options.encrypt && !encryptionKey) {
                throw new Error("No encryption key given");
            }
            return uploadQueue.enqueue(1, function () {
                return Bluebird.resolve(_this.blobs).bind(_this).map(function (blobWithMetaData) {
                    console.info("Uploading blob");
                    if (_this.options.encrypt) {
                        return _this.uploadAndEncryptPreparedBlob(encryptionKey, blobWithMetaData.blob);
                    }
                    return _this.uploadPreparedBlob(blobWithMetaData.blob);
                });
            });
        };
        _this._createSizeData = function (size) {
            return resizeQueue.enqueue(1, function () {
                return _this._resizeFile(size).then(function (resizedImage) {
                    return ImageUpload.blobToDataSet(blobService.createBlob(resizedImage.blob)).then(function (data) {
                        data.content.gif = _this.isGif;
                        data.content.width = resizedImage.width;
                        data.content.height = resizedImage.height;
                        return __assign({}, data, { size: size });
                    });
                });
            });
        };
        _this.prepare = h.cacheResult(function () {
            _this.isGif = !!_this.file.type.match(/image.gif/i);
            var sizes = _this.isGif ? _this.options.gifSizes : _this.options.sizes;
            return Bluebird.resolve(sizes)
                .map(_this._createSizeData)
                .then(_this._removeUnnededBlobs);
        });
        _this._removeUnnededBlobs = function (blobs) {
            var lastBlob, result = {};
            _this.blobs = blobs.sort(sizeSorter).filter(function (blob) {
                var keep = !lastBlob || _this.isGif || sizeDiff(lastBlob, blob) > _this.options.minimumSizeDifference;
                if (keep) {
                    lastBlob = blob;
                }
                result[blob.size.name] = lastBlob;
                return keep;
            });
            return result;
        };
        _this.getImage = h.cacheResult(function () {
            return ImageUpload.imageLibLoad(_this.getUrl());
        });
        _this._resizeFile = function (sizeOptions) {
            var options = __assign({}, sizeOptions.restrictions || {}, { canvas: true });
            return _this.getImage().then(function (img) {
                if (_this.isGif && !sizeOptions.restrictions) {
                    return {
                        blob: _this.file,
                        width: img.width,
                        height: img.height
                    };
                }
                if (options.square) {
                    img = imageLib.scale(img, {
                        contain: true,
                        aspectRatio: 1
                    });
                }
                var canvas = ImageUpload.rotate(imageLib.scale(img, options), _this.rotation);
                return canvasToBlob(canvas, "image/jpeg").then(function (blob) {
                    return {
                        blob: blob,
                        width: canvas.width,
                        height: canvas.height
                    };
                });
            });
        };
        if (!ImageUpload.isImage(file)) {
            throw new Error("not an image!");
        }
        if (file.type.match(/image.gif/) && !_this.options.gif) {
            throw new Error("no gifs supported!");
        }
        return _this;
    }
    ImageUpload.isImage = function (file) {
        return file.type.match(/image.*/);
    };
    ImageUpload.imageLibLoad = function (file, options) {
        return new Bluebird(function (resolve, reject) {
            imageLib(file, function (canvas) {
                if (canvas.type === "error") {
                    reject(canvas);
                }
                else {
                    resolve(canvas);
                }
            }, options);
        });
    };
    ImageUpload.rotate = function (img, angle) {
        switch (angle) {
            case "0":
                return img;
            case "90":
                return ImageUpload.rotate90(img);
            case "180":
                return ImageUpload.rotate180(img);
            case "270":
                return ImageUpload.rotate270(img);
        }
        return img;
    };
    ;
    ImageUpload.rotateInternal = function (angle, img, flipRatio) {
        var canvas = document.createElement("canvas");
        if (flipRatio) {
            canvas.width = img.height;
            canvas.height = img.width;
        }
        else {
            canvas.width = img.width;
            canvas.height = img.height;
        }
        var diff = canvas.width - canvas.height;
        var newCtx = canvas.getContext("2d");
        if (newCtx === null) {
            throw new Error("could not initialize canvas context");
        }
        newCtx.translate(canvas.width / 2, canvas.height / 2);
        newCtx.rotate(angle);
        newCtx.translate(-canvas.width / 2, -canvas.height / 2);
        newCtx.drawImage(img, flipRatio ? diff / 2 : 0, flipRatio ? -diff / 2 : 0);
        return canvas;
    };
    ;
    ImageUpload.rotate90 = function (img) {
        var angle = Math.PI / 2;
        return ImageUpload.rotateInternal(angle, img, true);
    };
    ;
    ImageUpload.rotate180 = function (img) {
        var angle = Math.PI;
        return ImageUpload.rotateInternal(angle, img, false);
    };
    ;
    ImageUpload.rotate270 = function (img) {
        var angle = 3 * Math.PI / 2;
        return ImageUpload.rotateInternal(angle, img, true);
    };
    ;
    return ImageUpload;
}(FileUpload));
export default ImageUpload;



//////////////////
// WEBPACK FOOTER
// ./js/services/imageUpload.service.ts
// module id = BHBR
// module chunks = 1 2